import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Picture } from '../models/picture.model';

@Injectable({
  providedIn: 'root'
})
export class PictureService {

  constructor(
    private apiService: ApiService
  ) { }

  getBarPictures(barId: string): Promise<Picture[]> {
    let url = `pictures/public?barId=${barId}`;
    return this.apiService.doGet(url);
  }

}
